const getCurrentMonthRange = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = now.getMonth();
  const firstDay = new Date(year, month, 1);
  const lastDay = new Date(year, month + 1, 0);
  
  const formatDate = (date) => {
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const d = String(date.getDate()).padStart(2, '0');
    return `${y}-${m}-${d}`;
  };
  
  return [formatDate(firstDay), formatDate(lastDay)];
};

const getSalesInitialState = () => ({
  filter: {
    isFilterActive: true,
    filterSaleCompetencyDate: getCurrentMonthRange(),
    filterSaleStatuses: [],
    filterSaleSources: [],
    filterSaleProducts: [],
    filterSaleBankAccounts: [],
    filterSaleCategories: [],
    filterInvoiceDate: [],
    filterInvoiceStatus: 'all',
    filterSalesIds: [],
    filterExternalsIds: [],
    filterSubscriptionExternalsIds: [],
    filterExternalsIdsNull: false,
    filterSubscriptionExternalsIdsNull: false,
    filterDueDate: [],
    filterReceivedDate: [],
  },
  sortModel: [
    {
      colId: 'competency_date',
      sort: 'desc',
    },
  ],
  pageSize: 50,
  currentPage: 0,
});

export default getSalesInitialState;
